<section class="edit-profile-section">
    <header class="row page-header">
        <div class="container">
            <div class="row">
                <div class="col-md-6">
                    <h2 class=title>SETTINGS</h2>
                </div>
                <div class="col-md-6 text-end">
                    <div class="top-buffer-20">
                        <label>Joined</label>
                        &nbsp;
                        <label>{{joinedOn | date: 'MMM dd, yyyy'}}</label>
                    </div>
                </div>
            </div>
        </div>
    </header>
    <main>
        <div class="container">
            <form [formGroup]="userProfileForm">
                <div class="form-section clear-border">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group top-buffer-20">
                                <label for="firstName">First Name</label><span class="required">*</span>
                                <input type="text" id="firstName" formControlName="firstName" pattern="[a-zA-Z0-9\.\-\s_]{0,50}" maxlength="50" minlength="3" class="form-control" />
                                <span [hidden]="firstName.untouched || firstName.valid" class="red">
                                    <span *ngIf="firstName.errors && firstName.errors.pattern">Only 'Alphanumeric', 'underscore' and 'Dash' characters allowed</span>
                                </span>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group top-buffer-20">
                                <label for="lastName">Last Name</label><span class="required">*</span>
                                <input type="text" id="lastName" formControlName="lastName" pattern="[a-zA-Z0-9\.\-\s_]{0,50}" maxlength="50" minlength="3" class="form-control" />
                                <span [hidden]="lastName.untouched || lastName.valid" class="red">
                                    <span *ngIf="lastName.errors && lastName.errors.pattern">Only 'Alphanumeric', 'underscore' and 'Dash' characters allowed</span>
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6 col-sm-10">
                            <div class="form-group top-buffer-20">
                                <label for="phone">Phone</label>
                                <input type="text" id="phone" formControlName="phone" class="form-control" pattern="((001[ -]?)?(\d{3}[ -]?\d{3}[ -]?\d{4}))?" />
                                <span [hidden]="phone.untouched || phone.valid" class="red">
                                    <span *ngIf="phone.errors && phone.errors.pattern">Phone should be like xxx xxx xxxx </span>
                                </span>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-10">
                            <div class="form-group top-buffer-20">
                                <label for="email">Email</label><span class="required">*</span>
                                <input type="email" id="email" formControlName="email" required class="form-control" />
                                <span [hidden]="email.untouched || email.valid" class="red">
                                    <span *ngIf="email.errors && email.errors.required">Email is required</span>
                                    <span *ngIf="email.errors && email.errors.pattern">Email should be like email&#64;server.com</span>
                                </span>
                            </div>
                        </div>
                    </div>
                    <footer class="text-end top-buffer-20">
                        <!-- <button type="button" class="btn btn-cancel" (click)="onCancel()">Cancel</button> -->
                        <button [disabled]="!(userProfileForm.valid || (userProfileForm.dirty && userProfileForm.valid))" type="submit" (click)="saveProfile()" class="btn btn-success text-end">
                            SAVE PROFILE
                        </button>
                    </footer>
                </div>
            </form>  

            <form [formGroup]="pageForm">
                <div class="form-section clear-border">
                    <div class="row">
                        <div class="col-md-12">
                            <h2>Update Password</h2>
                            <label>Passwords should have at least six characters that includes: lowercase letters,numbers and symbols</label>
                        </div>
                    </div>
                    <div class="row top-buffer-20 feedback-container">
                        <div class="col-md-6 offset-md-2">
                            <div class="alert alert-success" role="alert" *ngIf="successMessage != ''">
                                <span class="glyphicon glyphicon-ok" aria-hidden="true"></span> {{ successMessage }}
                            </div>
                            <div class="alert alert-danger" role="alert" *ngIf="feedbackMessages.length > 0">
                                <div *ngFor="let msg of feedbackMessages">
                                    <span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
                                    <span class="visually-hidden">Error:</span> {{ msg.details }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row top-buffer-20">
                        <div class="col-md-4 top-buffer-20">
                            <label>Current Password</label><span class="required">*</span>
                            <input type="password" class="form-control" formControlName="currentPassword" placeholder="Current Password" maxlength="20"
                                required #currentPassword />
                            <sp-field-error [controlName]="'Current Password'" [control]="pageForm?.controls?.currentPassword"></sp-field-error>
                            <div class="col-md-6 top-buffer-20">
                                <a class="showMyTyping" (click)="showCurrentPassword($event)">{{ showTypingText }}</a>
                            </div>
                        </div>
                        <div class="col-md-4 top-buffer-20">
                            <label>New Password</label><span class="required">*</span>
                            <input type="password" class="form-control" formControlName="newPassword" placeholder="New Password" maxlength="20"
                                required />
                            <sp-field-error [controlName]="'New Password'" [control]="pageForm?.controls?.newPassword"></sp-field-error>
                        </div>
                        <div class="col-md-4 top-buffer-20">
                            <label>Confirm Password</label><span class="required">*</span>
                            <input type="password" class="form-control" formControlName="confirmPassword" placeholder="Confirm Password" maxlength="20"
                                required />
                            <sp-field-error [controlName]="'Confirm Password'" [control]="pageForm?.controls?.confirmPassword"></sp-field-error>
                        </div>                    
                    </div>
                    <footer class="text-end top-buffer-20">
                        <button [disabled]="!pageForm.valid || isSubmitting" type="submit" (click)="onChangePassword()" class="btn btn-success text-end">
                            SAVE NEW PASSWORD
                        </button>
                    </footer>
                </div>
            </form>
        </div>
    </main>
</section>
